import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages, isOldButtonFactory } from '../utility/getTemplateData'
import { StyleSheet, css } from '../utility/paypalAphrodite';
import { isLTR as isLeftToRight, getPPCCStatus } from '../utility/helper';

import PPCC from './ppcc';

const MERCHANT_PPCC_CONFIRMED_STATUS = 'Confirmed';
const isLTR = isLeftToRight();
const messages = localsMessages('common/subHeader');
const STYLES = StyleSheet.create({
	fontFamilyMedium: {
		fontFamily: 'pp-sans-big-medium',
	},
	fontFamilyRegular: {
		fontFamily: 'pp-sans-big-regular',
	},
	textSize15: {
		fontSize: 15,
	},
	noMargin: {
		margin: '0px auto',
	},
	headerPurpose: {
		marginBottom: 0,
		lineHeight: 1.3,
	},
	headerDonationId: {
		margin: 0,
		lineHeight: 1.3,
	},
	checkMark: {
		color: '#005EA6',
		cursor: 'pointer',
	}
})

class SubHeader extends React.Component {
	constructor() {
		super();
		const { label: { donateto = '', purpose: purposeLabel = '' } = {} } = messages || {};
		this.state = { donateto, purposeLabel, };
	}

	formatOrgName() {
		let { label, orgName } = this.props;
		label = label && label.toString().replace(/\s/g, '').toUpperCase();
		let OName = orgName && orgName.toString().replace(/\s/g, '').toUpperCase();
		return label.includes(OName) ? '' : orgName;
	}

	shouldShowDonationId() {
		if (this.props.page === 'member' || this.props.page === 'crossborder') {
			return true;
		}
		return isOldButtonFactory();
	}

	render() {
		let { donateto = '', purposeLabel = '' } = this.state;
		let donationName = this.props.label;
		let orgName = this.formatOrgName();
		let donationId = this.props.donationId;
		let { formattedDonationName, formattedOrgName, formattedDonationId } = {};

		if (donationName === orgName) {
			formattedDonationName = donationName;
			formattedOrgName = '';
		} else {
			formattedDonationName = donationName
		}

		if (orgName && !donationId) {
			if (donationName !== orgName) {
				formattedOrgName = isLTR ? `${purposeLabel} ${orgName}` : `${orgName} ${purposeLabel}`;
			}
		}

		if (!orgName && donationId) {
			formattedDonationId = isLTR ? `${purposeLabel} ${donationId}` : `${donationId} ${purposeLabel}`;
		}

		if (orgName && donationId) {
			if (donationName !== orgName) {
				formattedOrgName = isLTR ? `${purposeLabel} ${orgName}` : `${orgName} ${purposeLabel}`;
				formattedDonationId = donationId;
			} else {
				formattedOrgName = '';
				formattedDonationId = isLTR ? `${purposeLabel} ${donationId}` : `${donationId} ${purposeLabel}`;
			}
		}

		return (
			<div className="col-xs-12 col-sm-12 col-md-12 donate_sub_header">
				<h4
					className={`${css(STYLES.fontFamilyMedium, STYLES.textSize15, STYLES.noMargin)} text-center`}
					id="headerDonateTo">
					{donateto}
				</h4>
				<h4
					className={`${css(STYLES.fontFamilyMedium, STYLES.textSize15, STYLES.noMargin)} text-center`}
					id="headerDonateToName">
					{formattedDonationName}
					{getPPCCStatus() === MERCHANT_PPCC_CONFIRMED_STATUS ? <PPCC /> : null}
				</h4>

				{formattedOrgName && <h5 className={`${css(STYLES.fontFamilyRegular, STYLES.textSize15, STYLES.headerPurpose)} text-center`}>
					{formattedOrgName}
					</h5>
				}
				{formattedDonationId && this.shouldShowDonationId() && <h5 className={`${css(STYLES.fontFamilyRegular, STYLES.textSize15, STYLES.headerDonationId)} text-center`}>
					{formattedDonationId}
					</h5>
				}
			</div>
		);
	}
}

SubHeader.propTypes = {
	label: PropTypes.string.isRequired,
	orgName: PropTypes.string.isRequired,
	donationId: PropTypes.string,
	page: PropTypes.string
};

export default SubHeader



// WEBPACK FOOTER //
// ./components/subHeader.js